<!-- <app-loader *ngIf="!merchant"></app-loader> -->

<div class="client-page" [ngClass]="{ isEdit: isAdmin && !isWordpress && !editorPreviewMode, 'is-transparent': isWordpress }" [style.backgroundColor]="merchant?.settings?.backgroundColor || '#f8f9fa'">
  <div>

    <div class="editor-nav fixed-top d-flex justify-content-between" *ngIf="isAdmin && !isWordpress && !editorPreviewMode">
      <button class="btn btn-secondary btn-sm" [routerLink]="'./dashboard'"><i class="material-icons ico mr-1">arrow_back</i>{{'CLIENT.clientEditor.back' | translate}}</button>
      <button class="btn btn-secondary btn-sm" [routerLink]="'./editor'"><i class="material-icons ico mr-1">edit</i>{{'CLIENT.clientEditor.edit' | translate}}</button>
    </div>

    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="page-header text-center" [ngStyle]="getHeaderImg()" *ngIf="showHeader">
            <!-- <img class="bg" *ngIf="merchant" appLoadImage w="1000" [img]="merchant?.headerImage || getDefaultBgImage()" alt=""> -->
            <div class="overlay1" *ngIf="!merchant?.settings?.notShowTitle"></div>
            <div class="header-content">
              <div class="logo-avatar" *ngIf="merchant?.settings?.logoImage">
                <img [src]="merchant?.settings?.logoImage + '?w=200'" alt="{{ merchant?.settings?.pageHeader || merchant?.name }}">
              </div>
              <h1 class="name {{ merchant?.settings?.fontSize }}" [ngStyle]="{ 'font-family': merchant?.settings?.font }" *ngIf="!merchant?.settings?.notShowTitle">
                {{ merchant?.settings?.pageHeader || merchant?.name }}
              </h1>
            </div>
            <div class="bg-grade" *ngIf="merchant?.settings?.facebookLink || merchant?.settings?.instagramLink || merchant?.settings?.websiteLink">
              <div class="d-flex justify-content-center">
                <a *ngIf="merchant?.settings?.websiteLink" [href]="merchant?.settings?.websiteLink" target="_blank">
                  <i class="ico-social ico-website"></i>
                </a>
                <a *ngIf="merchant?.settings?.facebookLink" [href]="merchant?.settings?.facebookLink" target="_blank">
                  <i class="ico-social ico-fb-2"></i>
                </a>
                <a *ngIf="merchant?.settings?.instagramLink" [href]="merchant?.settings?.instagramLink" target="_blank">
                  <i class="ico-social ico-ig"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" #cardBody>
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6">
          <div class="card shadow-4 rd-3" [class.no-header]="!showHeader">
            <!-- <div class="nav" *ngIf="!loading">
              <app-wizard-navigation (changePage)="currentPage = $event" [numberOfPages]="6" [currentPage]="currentPage" [readOnly]="false"></app-wizard-navigation>
            </div> -->
            <ng-container *ngIf="pageType == 'newBooking'">
              <div class="card-nav" data-nosnippet>
                <!-- (click) hacky way to jump providers when selected automaticly  -->
                <i
                  class="btn-back material-icons"
                  (click)="
                    currentPage === 4 && ((selectedProviders.length && selectedProviders[0].auto) || preselectedProvider)
                      ? (currentPage = currentPage - 2)
                      : (currentPage = currentPage - 1)
                  "
                  *ngIf="showBackBtn() && currentPage !== 7"
                >
                  arrow_back
                </i>

                <h3 *ngIf="!preselectedProvider">{{ 'CLIENT.clientPage.newBooking' | translate }}</h3>
                <p *ngIf="(preselectedStore || multipleStores) && currentPage !== 1 && currentPage !== 6 && selectedStore" class="text-gray">{{selectedStore.name}} <span *ngIf="preselectedServiceId && selectedServices?.length"> - {{selectedServices?.[0]?.name}} <span *ngIf="selectedServices?.[0]?.price > 0">({{selectedServices?.[0]?.price | currency:merchant.currency:'symbol-narrow':'1.0-2'}})</span></span></p>
                <p class="text-gray" *ngIf="googleReserveToken && selectedStoreAddress " [innerHTML]="selectedStoreAddress"></p>

                <div class="avatar-wrapper" *ngIf="preselectedProvider && selectedProviders[0]?.profileImage && showHeader">
                  <app-upload-avatar-image
                    classes="big borders"
                    [image]="selectedProviders[0]?.profileImage"
                    [name]="selectedProviders[0]?.name"
                  ></app-upload-avatar-image>
                </div>
                <h3 *ngIf="preselectedProvider && selectedProviders[0]">{{ selectedProviders[0].name }}</h3>
              </div>

              <div class="card-body">
                <app-client-stores
                  [merchant]="merchant"
                  (saved)="
                    selectedStore = $event;
                    currentPage = currentPage + 1;
                    preselectedProviderOrStoreSlug = null;
                    selectedProviders = null;
                    preselectedProvider = null
                  "
                  *ngIf="currentPage === 1 && !loading"
                  [@flyInOut]
                ></app-client-stores>
                <app-client-services
                  [preselectedProviderId]="preselectedProvider ? selectedProviders[0]?.id : null"
                  [store]="selectedStore"
                  [merchant]="merchant"
                  (saved)="saveServices($event)"
                  *ngIf="currentPage === 2 && !loading"
                  [@flyInOut]
                ></app-client-services>
                <app-client-providers
                  [store]="selectedStore"
                  [services]="selectedServices"
                  [bypassChooseProviders]="merchant?.bypassChooseProviders"
                  [mandatoryChooseProviders]="merchant?.mandatoryChooseProviders"
                  (saved)="selectedProviders = $event; currentPage = currentPage + 1"
                  *ngIf="currentPage === 3 && !loading"
                  [@flyInOut]
                ></app-client-providers>
                <app-client-day
                  [store]="selectedStore"
                  [providers]="selectedProviders"
                  (saved)="selectedDay = $event; currentPage = currentPage + 1"
                  [services]="selectedServices"
                  *ngIf="currentPage === 4 && !loading"
                  [@flyInOut]
                ></app-client-day>
                <app-client-time
                  [day]="selectedDay"
                  (saved)="selectedTime = $event; currentPage = currentPage + 1"
                  *ngIf="currentPage === 5 && !loading"
                  [@flyInOut]
                ></app-client-time>
                <app-client-confirm
                  [merchant]="merchant"
                  [store]="selectedStore"
                  (saved)="finalBooking = $event; currentPage = currentPage + 1"
                  [services]="selectedServices"
                  [providers]="selectedProviders"
                  [mandatoryEmailOnBooking]="merchant?.mandatoryEmailOnBooking"
                  [day]="selectedDay"
                  [time]="selectedTime"
                  *ngIf="currentPage === 6"
                  [googleReserveToken]="googleReserveToken"
                ></app-client-confirm>
                <app-client-success [store]="selectedStore" [booking]="finalBooking" *ngIf="currentPage === 7"></app-client-success>
              </div>
            </ng-container>
            <ng-container *ngIf="pageType == 'cancelBooking'">
              <div class="card-nav">
                <h3>{{ 'CLIENT.clientPage.cancelBooking' | translate }}</h3>
              </div>

              <div class="card-body">
                <app-client-cancel-booking></app-client-cancel-booking>
              </div>
            </ng-container>
            <ng-container *ngIf="pageType == 'payBooking'">
              <div class="card-nav">
                <h3>{{ 'Pagar marcação' }}</h3>
                <!-- FIXME missing translation -->
              </div>

              <div class="card-body" *ngIf="merchant">
                <app-client-pay-booking [merchant]="merchant"></app-client-pay-booking>
              </div>
            </ng-container>
          </div>

          <p class="book-footer text-center mb-3" [innerHTML]="merchant?.settings?.footerMsg" *ngIf="isBrowser && showFooter && merchant?.settings?.footerMsg"></p>
          <p class="book-footer text-center mb-3">
            <a class="help-footer" target="_blank" rel="canonical" href="/cookie-policy">{{ 'LANDING.landing.cookiesCta' | translate }}</a>
          </p>

        </div>
      </div>
    </div>
  </div>

  <!-- <div class="text-center p-3 py-5" *ngIf="showHeader">
    <small>
      <a class="help-footer" target="_blank" href="/cookie-policy">{{ 'LANDING.landing.cookies' | translate }}</a>
    </small>
  </div> -->

  <div *ngIf="merchant?.plan === 'free'">
    <div class="free-footer flex-column d-flex justify-content-center align-items-center w-100">
      <a [href]="'//' + powerdByLink + '?utm_source=buk&utm_medium=site&utm_campaign=merchantSiteFooter'" target="_blank">
        <img class="buk-logo mb-2" src="/assets/buk.png" alt="" />
        <p class="strong mb-2">Powered by {{host}}</p>
        <p>
          {{'CLIENT.clientPage.footer1' | translate}} <br />
          {{'CLIENT.clientPage.footer2' | translate}}.
        </p>
      </a>
    </div>
  </div>

</div>

